<template>
  <img ref="moveImageEl"
    id="move-image"
    :src="moveImagePath"
    v-show="isShowMoveImage"
    :style="moveImageStyle"
    alt=""
  >
</template>

<script>
export default {
  name: 'SelectStyleImageMove',
  props: {
    url: { type: String, default: '' },
    imageRef: { type: String, default: '' } // ※元は image_ref。親側に合わせてどちらかに統一推奨
  },
  data () {
    return {
      moveImagePath: null,
      isShowMoveImage: false,
      moveImageStyle: {}
    }
  },
  methods: {
    move (imagePath, pyFrom, pxFrom, pyTo, pxTo, width, height) {
      this.moveImagePath = imagePath
      this.isShowMoveImage = true

      this.moveImageStyle = {
        position: 'absolute',
        top: `${pyFrom}px`,
        left: `${pxFrom}px`,
        width: `${width}px`,
        height: `${height}px`,
        transform: 'translate(0px, 0px) scale(1,1)',
        transitionDuration: '0.5s',
        opacity: '0.7'
      }
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.moveImageStyle = {
            ...this.moveImageStyle,
            transform: `translate(${pxTo - pxFrom}px, ${pyTo - pyFrom}px) scale(0.6,0.6)`,
            transition: 'transform 0.5s'
          }
        })
      })
    },
    restore () {
      this.moveImagePath = null
      this.isShowMoveImage = false
      this.moveImageStyle = {}
    }
  }
}
</script>
